import { authRequest } from './client';
import {
  type CreateTariffInput,
  type ListTariffsResponse,
  type TariffDetailResponse,
  type TariffListItem,
  type TariffRuleItem,
  type UpdateTariffInput,
  type UpsertTariffRuleInput,
} from './types';

// ─── backoffice-api tariffs client ─────────────────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/tariffs` endpoints (Task
// 29 Part A). CONFIG_MANAGER-gated end to end. `deleteTariff`/
// `deleteTariffRule` hit routes that return `204 No Content` — `client.ts`'s
// `request()` was given a small guard for that status (this app's first
// void-returning DELETE call site) rather than attempting to JSON-parse an
// empty body.

export function listTariffs(): Promise<ListTariffsResponse> {
  return authRequest<ListTariffsResponse>('/tariffs');
}

export function createTariff(input: CreateTariffInput): Promise<TariffListItem> {
  return authRequest<TariffListItem>('/tariffs', { method: 'POST', body: JSON.stringify(input) });
}

export function getTariff(id: string): Promise<TariffDetailResponse> {
  return authRequest<TariffDetailResponse>(`/tariffs/${id}`);
}

export function updateTariff(id: string, input: UpdateTariffInput): Promise<TariffListItem> {
  return authRequest<TariffListItem>(`/tariffs/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export function deleteTariff(id: string): Promise<void> {
  return authRequest<void>(`/tariffs/${id}`, { method: 'DELETE' });
}

export function upsertTariffRule(
  tariffId: string,
  assetId: string,
  input: UpsertTariffRuleInput,
): Promise<TariffRuleItem> {
  return authRequest<TariffRuleItem>(`/tariffs/${tariffId}/rules/${assetId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export function deleteTariffRule(tariffId: string, assetId: string): Promise<void> {
  return authRequest<void>(`/tariffs/${tariffId}/rules/${assetId}`, { method: 'DELETE' });
}
